import { render } from "./EducationSection.vue?vue&type=template&id=14a92610&scoped=true"
import script from "./EducationSection.vue?vue&type=script&lang=js"
export * from "./EducationSection.vue?vue&type=script&lang=js"

import "./EducationSection.vue?vue&type=style&index=0&id=14a92610&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a92610"]])

export default __exports__